const DEV_HOSTNAMES = ["localhost", "local.ambifi.com", "dev-app.ambifi.com", "127.0.0.1", "::1"];

export function isTruthyFeatureFlag(value) {
	if (value === true || value === 1) {
		return true;
	}

	if (typeof value !== "string") {
		return false;
	}

	switch (value.trim().toLowerCase()) {
		case "1":
		case "true":
		case "yes":
		case "on": {
			return true;
		}
		default: {
			return false;
		}
	}
}

export function getFeatureFlagValue(flagName = "", urlParams = null) {
	if (!flagName) {
		return undefined;
	}

	if (urlParams && Object.prototype.hasOwnProperty.call(urlParams, flagName)) {
		return urlParams[flagName];
	}

	const urlParamValue = getCaseInsensitiveObjectValue(urlParams, flagName);
	if (urlParamValue !== undefined) {
		return urlParamValue;
	}

	if (typeof window === "undefined" || !window.location) {
		return undefined;
	}

	const searchValues = [window.location.search || ""];
	const hashValue = window.location.hash || "";
	const hashQueryIndex = hashValue.indexOf("?");
	if (hashQueryIndex !== -1) {
		searchValues.push(hashValue.substring(hashQueryIndex));
	}

	for (let i = 0; i < searchValues.length; i += 1) {
		try {
			const params = new URLSearchParams(searchValues[i]);
			const value = params.get(flagName);
			if (value !== null) {
				return value;
			}

			const caseInsensitiveValue = getCaseInsensitiveSearchParamValue(params, flagName);
			if (caseInsensitiveValue !== undefined) {
				return caseInsensitiveValue;
			}
		} catch (err) {
			// Continue checking other URL surfaces.
		}
	}

	return undefined;
}

function getCaseInsensitiveObjectValue(values, key) {
	if (!values || typeof values !== "object" || !key) {
		return undefined;
	}

	const normalizedKey = key.toLowerCase();
	const match = Object.keys(values).find(valueKey => valueKey.toLowerCase() === normalizedKey);
	return match ? values[match] : undefined;
}

function getCaseInsensitiveSearchParamValue(params, key) {
	if (!params || !key || typeof params.forEach !== "function") {
		return undefined;
	}

	const normalizedKey = key.toLowerCase();
	let matchedValue;

	params.forEach((value, valueKey) => {
		if (matchedValue === undefined && valueKey.toLowerCase() === normalizedKey) {
			matchedValue = value;
		}
	});

	return matchedValue;
}

export function isDevHost() {
	if (typeof window === "undefined" || !window.location || !window.location.hostname) {
		return false;
	}

	return DEV_HOSTNAMES.includes(window.location.hostname);
}

export function isProdUiForced(urlParams = null) {
	return (
		isTruthyFeatureFlag(getFeatureFlagValue("forceProdUi", urlParams))
		|| isTruthyFeatureFlag(getFeatureFlagValue("prodPreview", urlParams))
	);
}

export function isDevFeatureEnvironment(urlParams = null) {
	return isDevHost() && !isProdUiForced(urlParams);
}

export function isFutureFlagEnabled(urlParams = null) {
	return isTruthyFeatureFlag(getFeatureFlagValue("future", urlParams));
}

export function isFutureEnabled() {
	return true;
}

export function isFutureAiEnabled(urlParams = null) {
	return isTruthyFeatureFlag(getFeatureFlagValue("futureAi", urlParams));
}

export function isFutureExperienceEnabled(urlParams = null) {
	return isFutureFlagEnabled(urlParams) || isFutureAiEnabled(urlParams);
}

export function isDevDefaultFeatureEnabled(flagName, urlParams = null, impliedByFuture = false) {
	const explicitValue = getFeatureFlagValue(flagName, urlParams);
	if (explicitValue !== undefined) {
		return isTruthyFeatureFlag(explicitValue);
	}

	if (impliedByFuture && isFutureExperienceEnabled(urlParams)) {
		return true;
	}

	return isDevFeatureEnvironment(urlParams);
}

export function isAdminToolsEnabled(urlParams = null) {
	return isDevDefaultFeatureEnabled("adminTools", urlParams, true);
}

export function isSearchV2Enabled() {
	return true;
}

export function isActivityOpsEnabled(urlParams = null) {
	return isDevDefaultFeatureEnabled("activityOps", urlParams, true);
}

export function isBlockBankEnabled(urlParams = null) {
	return isFutureFlagEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("blockBank", urlParams));
}

export function isCopyFromActivityEnabled() {
	return true;
}

export function isItemContainerEnabled(urlParams = null) {
	return isFutureFlagEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("itemContainer", urlParams));
}

export function isMediaToolsEnabled(urlParams = null) {
	return isDevFeatureEnvironment(urlParams) || isFutureEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("mediaTools", urlParams));
}

export function isImageToolsEnabled(urlParams = null) {
	return (
		isDevFeatureEnvironment(urlParams)
		|| isFutureEnabled(urlParams)
		|| isTruthyFeatureFlag(getFeatureFlagValue("imageTools", urlParams))
		|| isMediaToolsEnabled(urlParams)
	);
}

export function isAiAssistantFeatureEnabled(urlParams = null) {
	return isFutureAiEnabled(urlParams) || isTruthyFeatureFlag(getFeatureFlagValue("aiAssistant", urlParams));
}
